import { IZipCode } from '@shared/services/palletising.service';

import * as XLSX from 'xlsx';

export function formatZipCodeToXLSX(ZipCodes: IZipCode[]): XLSX.WorkBook {
	const wb = XLSX.utils.book_new();
	const rows: Array<Array<string | number>> = [['ruleNumber', 'from', 'to', 'description']];

	for (const ZipCode of ZipCodes) {
		rows.push([ZipCode.ruleNumber, ZipCode.from, ZipCode.to, ZipCode.description || '']);
	}

	const sheet = XLSX.utils.aoa_to_sheet(rows);

	XLSX.utils.book_append_sheet(wb, sheet, 'ZipCodes');

	return wb;
}
